export class SoftwareBackgroundBlurError extends Error {
  constructor(
    message: string,
    readonly unavailable = false,
  ) {
    super(message);
    this.name = 'SoftwareBackgroundBlurError';
  }
}

export function backgroundBlurAbortError(): DOMException {
  return new DOMException('Background blur was stopped', 'AbortError');
}

export function throwIfBlurAborted(signal?: AbortSignal): void {
  if (signal?.aborted) throw signal.reason ?? backgroundBlurAbortError();
}
